import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction, Box, Badge } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import PaymentIcon from '@mui/icons-material/Payment';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CampaignIcon from '@mui/icons-material/Campaign';
import ApiService from '../api/ApiService';

const BottomMenu = () => {
    const navigate = useNavigate();
    const currentPath = window.location.pathname;
    const [unreadCount, setUnreadCount] = useState(0);

    const loadUnreadCount = () => {
        ApiService.getActiveAnnouncements()
            .then((list) => setUnreadCount(list.filter((a) => !a.isRead).length))
            .catch(() => {});
    };

    useEffect(() => {
        loadUnreadCount();
        const onVisibility = () => { if (document.visibilityState === 'visible') loadUnreadCount(); };
        window.addEventListener('fcm-message', loadUnreadCount);
        document.addEventListener('visibilitychange', onVisibility);
        return () => {
            window.removeEventListener('fcm-message', loadUnreadCount);
            document.removeEventListener('visibilitychange', onVisibility);
        };
    }, []);

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        navigate(`/${newValue}`);
    };

    return (
        <Box sx={{ pb: 7 }}>
            <BottomNavigation
                value={currentPath.replace('/', '')}
                onChange={handleChange}
                sx={{ position: 'fixed', bottom: 0, width: '100%' }}
            >
                <BottomNavigationAction label="Главная" value="students" icon={<HomeIcon />} />
                <BottomNavigationAction label="Платежи" value="payments" icon={<PaymentIcon />} />
                <BottomNavigationAction label="Обращения" value="cases" icon={<ContactSupportIcon />} />
                <BottomNavigationAction
                    label="Объявления"
                    value="announcements"
                    icon={
                        <Badge badgeContent={unreadCount} color="error">
                            <CampaignIcon />
                        </Badge>
                    }
                />
                <BottomNavigationAction label="Профиль" value="profile" icon={<AccountCircleIcon />} />
            </BottomNavigation>
        </Box>
    );
};

export default BottomMenu;
